<template>
  <div class="field-search" v-if="compareType">
    <el-select
      class="key-select"
      v-model="cid"
      filterable
      placeholder="请选择"
      @change="changeSearchKey"
    >
      <el-option
        v-for="item in searchableControls"
        :key="item._cid"
        :label="item.name"
        :value="item._cid"
      ></el-option>
    </el-select>
    <compare-value
      v-if="compareType !== 'Number'"
      :control="curControl"
      :compare-method="compareMethod[0]"
      v-model="value"
      @input="searchData()"
      from="sheet_frontend"
      depart-from="query"
      :sheet-id="sheetId"
      hide-tip
    ></compare-value>
    <special-compare-value
      v-else
      class="special-value"
      ref="specialCompare"
      :control="curControl"
      :compare-method="compareMethod"
      @input="searchData"
    ></special-compare-value>
    <div
      class="icon-search-box"
      :style="['time', 'date'].includes(curControl._type) ? 'height:30px' : 'height:auto'"
      @click="reSearch"
    >
      <i class="el-icon-search"></i>
    </div>
  </div>
</template>

<script>
import CompareValue from "@/components/UIComponents/ConditionList/CompareValue"
import { getCompareMethods } from "@/utils/workFlow"
import SpecialCompareValue from "@/components/Sheet/QuickSearch/SpecialCompareValue"
import { getFilter } from "@/utils/sheet"
import department from "@/mixins/department"

export default {
  name: "field-search",
  components: { SpecialCompareValue, CompareValue },
  props: {
    controls: Array,
    needSystemField: {
      type: Boolean,
      default: false
    },
    sheetId: String
  },
  mixins: [department],
  data() {
    return {
      cid: "",
      value: [],
      checkCompareMethod: "",
      includeSubDepartment: false
    }
  },
  computed: {
    curControl() {
      return this.searchableControls.find(control => control._cid == this.cid) || {}
    },
    compareType() {
      if (!this.curControl._cid) return null
      const { compareType } = getCompareMethods({
        type: this.curControl._type,
        oneFlag: this.curControl.oneFlag,
        from: "sheet_frontend"
      })
      return compareType
    },
    compareMethod() {
      return this.compareType === "Number" ? ["大于等于", "小于等于"] : ["包含"]
    },
    searchableControls() {
      let controls = (this.controls || []).concat(
        this.needSystemField
          ? [
              { name: "创建人", _cid: "cid", _type: "staff" },
              { name: "负责人", _cid: "oid", _type: "staff" },
              { name: "参与人", _cid: "pts", _type: "staff" },
              { name: "最后修改人", _cid: "upid", _type: "staff" },
              { name: "创建时间", _cid: "cat", _type: "time", timeType: "年月日时分秒" },
              { name: "最后修改时间", _cid: "uat", _type: "time", timeType: "年月日时分秒" }
            ]
          : []
      )
      return controls.filter(control => {
        const { compareType } = getCompareMethods({
          type: control._type,
          from: "sheet_frontend"
        })
        return Boolean(compareType)
      })
    }
  },
  created() {
    this.$on("department-status-change", t => {
      this.includeSubDepartment = t
      this.searchData()
    })
  },
  methods: {
    changeSearchKey() {
      this.value = []
    },
    reset() {
      this.cid = this.searchableControls.find(c => c.main)?._cid
      this.value = []
      this.$refs.specialCompare?.clear()
    },
    reSearch() {
      this.searchData()
      this.$emit("reSearch")
    },
    searchData() {
      this.$nextTick(() => {
        if (!this.cid) return this.$message.warning("请先选择要搜索的字段！")
        if (this.compareType !== "Number") {
          let value = []
          if (this.curControl._type === "department" && this.includeSubDepartment) {
            value = this.getFilterDepartmentIds(this.value)
          } else {
            value = this.value
          }
          let filter = getFilter(this.curControl, this.compareMethod[0], value)
          this.$emit("search", [[filter]])
        } else {
          let filters = this.$refs.specialCompare.getFilters(this.curControl)
          this.$emit("search", [filters])
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.field-search {
  display: flex;
  width: 360px;
  ::v-deep {
    .el-input__validateIcon {
      display: none;
    }
    .compare-value {
      flex: 1;
      .main-value {
        .user-scope-selector-container,
        .is-text,
        .el-input__inner {
          border-radius: unset !important;
        }
      }
    }
    .key-select {
      width: 100px;
      .el-input.is-focus .el-input__inner {
        border-color: #dcdfe6;
      }
      .el-input__inner {
        border-radius: 4px 0 0 4px;
        border-right: none;
        &:hover,
        &:focus {
          border-color: #dcdfe6;
        }
      }
    }
  }
  .icon-search-box {
    @include flex-center;
    background-color: #f5f7fa;
    color: #909399;
    border: 1px solid #dcdfe6;
    border-left: none;
    border-radius: 0 4px 4px 0;
    padding: 0 12px;
    font-size: 14px;
    cursor: pointer;
  }
  .special-value {
    flex: 1;
    ::v-deep {
      .time {
        width: 100% !important;
      }
      .number-range {
        border-radius: unset;
      }
      .el-input__inner {
        border-radius: unset !important;
      }
    }
  }
}
</style>
